import styled from 'styled-components'
import variables, { colors, device } from '../../../Styled/variables'

export const Label = styled.label`
  color: ${({ isError }: { isError?: boolean }) =>
    isError ? colors.messegesRed : colors.greyTextWhiteBg};
  font-size: 10px;
  position: absolute;
  left: 13px;
  top: -7px;
  padding: 0 2px;
  pointer-events: none;
  background: ${colors.white};
  background: ${colors.white};
  transition: transform 100ms ease;
  z-index: 100;
`

export const Input = styled.input`
  border: 1px solid
    ${({ isError }: { isError?: boolean }) =>
      isError ? colors.messegesRed : colors.greyStroke};
  background: ${colors.white};
  height: 48px;
  border-radius: 8px;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  outline: none;
  padding: 13px 16px 16px 16px;
  width: 100%;
  color: ${colors.mainText};
  transition: border 0.3s;

  &::placeholder {
    color: ${colors.greyTextWhiteBg};
  }
`

export const ErrorTextBlock = styled.div`
  text-align: left;
  p {
    color: ${colors.messegesRed};
    font-size: ${variables.fontSize14};
    font-weight: 400;
  }
  margin-top: 0;
  margin-bottom: -7px;
  display: flex;
  gap: 4px;

  @media ${device.mobileMax} {
    gap: 0;
    flex-direction: column;
  }
`

export const RegisterLogin = styled.span`
  color: ${colors.green};
  border-bottom: 1px dotted ${colors.green};
  line-height: 21px;
`
export const LoginLink = styled.a`
  text-decoration: none;
  color: ${colors.mainText};
`
